<template>
  <div>
    <px-view-header title="Ofertas" :breadcrumbs="breadcrumbs"/>

    <px-ofertas-header @refresh="refresh" @change="onChangeFilter"/>
    <px-ofertas-list
      @update="refresh"
      :ofertas="ofertas"
      :loading="loading"
      @change="onChangeOptions"
      :options-list="optionsList"
    />
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import OfertasService from './ofertas-service';
import OfertasHeader from './OfertasHeader.vue';
import OfertasList from './OfertasList.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Ofertas' },
      ],
      searchText: null,
      ofertas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 25,
        offset: 0,
        filter: '',
        sort: 'titulo',
      },
      loading: false,
      optionsList: {},
    };
  },
  methods: {
    refresh() {
      this.getOfertas();
    },
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getOfertas();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getOfertas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getOfertas() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return OfertasService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.ofertas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxOfertasHeader: OfertasHeader,
    pxOfertasList: OfertasList,
  },
};
</script>
